import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface AppState {
  isMaintenanceMode: boolean
  maintenanceMessage: string | null
  lastChecked: string | null
}

const initialState: AppState = {
  isMaintenanceMode: false,
  maintenanceMessage: null,
  lastChecked: null,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setMaintenanceMode(
      state,
      action: PayloadAction<{ isMaintenance: boolean; message?: string }>
    ) {
      state.isMaintenanceMode = action.payload.isMaintenance
      state.maintenanceMessage = action.payload.message || 'System is under scheduled maintenance.'
      state.lastChecked = new Date().toISOString()
    },
    clearMaintenanceMode(state) {
      state.isMaintenanceMode = false
      state.maintenanceMessage = null
      state.lastChecked = new Date().toISOString()
    },
  },
})

export const { setMaintenanceMode, clearMaintenanceMode } = appSlice.actions
export default appSlice.reducer
